import { Controller } from "@hotwired/stimulus";

// WebKit hands a frame's print() to the browser app. Safari on iPhone prints the frame, but Chrome
// and older Safari on iPad print the page behind it, so iOS keeps the link's own navigation.
const iosFamily = () => navigator.maxTouchPoints > 1 && /Mac|iP(ad|hone|od)/.test(navigator.platform);

/**
 * Print Controller
 *
 * Handles printing functionality
 */
export default class extends Controller {
  disconnect() {
    this.removeFrame();
  }

  print() {
    window.print();
  }

  printUrl(event) {
    if (iosFamily()) return;
    event.preventDefault();
    const link = event.currentTarget;
    if (link.hasAttribute("aria-busy")) return;

    // Chrome's PDF viewer never fires afterprint, so a finished PDF print leaves its frame behind.
    this.removeFrame();
    link.setAttribute("aria-busy", "true");

    this.frame = document.createElement("iframe");
    this.frame.setAttribute("aria-hidden", "true");
    this.frame.tabIndex = -1;
    this.frame.style.cssText = "position: absolute; width: 0; height: 0; border: 0; visibility: hidden;";
    this.frame.addEventListener("load", () => {
      link.removeAttribute("aria-busy");
      const frameWindow = this.frame.contentWindow;
      frameWindow.addEventListener("afterprint", () => this.removeFrame(), { once: true });
      frameWindow.print();
    }, { once: true });
    this.frame.src = link.href;
    document.body.appendChild(this.frame);
  }

  removeFrame() {
    this.frame?.remove();
    this.frame = null;
  }
}
